import './instagram_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramMediaContent extends Monitoring.Models.SocialContents.InstagramContent

  author: ->
    return @data().user || {}

  image: ->
    return '' unless @data().images?
    return @data().images.low_resolution.url

  fullImage: ->
    return '' unless @data().images?
    return @data().images.standard_resolution.url

  video: ->
    return '' unless @data().videos?
    return @data().videos.low_bandwidth

  isImage: ->
    return @data().images && (@data().images.low_resolution || @data().images.standard_resolution) && !@isVideo()

  isVideo: ->
    return @data().videos && @data().videos.low_bandwidth && @data().videos.low_bandwidth != ''

  content: ->
    return if @caption() then @caption().text else ''

  getRootParentId: ->
    @numeric_id()
